module.exports = __webpack_public_path__ + "PERUVIANhome-14.64563693.png";